// extracted by mini-css-extract-plugin
module.exports = {"member_container":"single-speaker-module--member_container--TipB4","name":"single-speaker-module--name--1NxJF"};